import { Routes } from '@angular/router';

//import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
//import { LockscreenComponent } from './lockscreen/lockscreen.component';
import { SigninComponent } from './signin/signin.component';
//import { SignupComponent } from './signup/signup.component';
import { NotFoundComponent } from './not-found/not-found.component';
//import { ErrorComponent } from './error/error.component';
import { LoadingComponent } from './loading/loading.component';
import { ErrorComponent } from './error/error.component';
import { SupportTicketComponent } from '@mycommon/support-ticket/support-ticket.component';
//import { LockscreenComponent } from './lockscreen/lockscreen.component';
//import { LoginComponent } from '../login/login.component';

export const SessionsRoutes: Routes = [
  {
     path: '',
     children: [
       //{
  //     path: 'signup',
  //     component: SignupComponent,
  //     data: { title: 'Signup' }
  //   },
  //   {
  //     path: 'login',
  //     component: LoginComponent,
  //     data :{ title: 'Login' }
  //   },
   {
    path: 'signin',
    component: SigninComponent,
    data: { title: 'Signin' }
  }, 
  {
    path: 'support',
    component: SupportTicketComponent,
    data: { title: 'Support' }
  }, 
  //{
  //   path: 'forgot-password',
  //   component: ForgotPasswordComponent,
  //   data: { title: 'Forgot password' }
  //}
  //  {
  //   path: 'lockscreen',
  //   component: LockscreenComponent,
  //   data: { title: 'Lockscreen' }
  // }, 
  {
    path: '404',
    component: NotFoundComponent,
    data: { title: 'Not Found' }
  },
  {
    path: 'error',
    component: ErrorComponent,
    data: { title: 'Error' }
  },
  {
    path: 'loading',
    component: LoadingComponent,
    data: { title: 'Loading' }
  }
]
  }
];